export default __webpack_public_path__ + "22fc3dd5dd77fd6acdc5017aae43e4b9.jpeg";